import loadable from '@loadable/component';
import {SliceNames} from './utils';

/* eslint-disable camelcase */
const COMPONENTS = {
    [SliceNames.CONTENT]: loadable(() => import('./components/content')),
    [SliceNames.FAQ]: loadable(() => import('./components/faq')),
    [SliceNames.FAQ_WITH_TITLE]: loadable(() =>
        import('./components/faq-with-title')
    ),
    [SliceNames.FEATURED_ICONS]: loadable(() =>
        import('./components/featured-icons')
    ),
    [SliceNames.FEATURED_IMAGES]: loadable(() =>
        import('./components/featured-images')
    ),
    [SliceNames.HERO]: loadable(() => import('./components/hero')),
    [SliceNames.HERO_WITH_IMAGE]: loadable(() =>
        import('./components/hero-with-image')
    ),
    [SliceNames.HTML_FORM]: loadable(() => import('./components/html-form')),
    [SliceNames.INTERNAL_LINK_LIST]: loadable(() =>
        import('./components/internal-link-list')
    ),
    [SliceNames.RICH_TEXT_WITH_TITLE]: loadable(() =>
        import('./components/rich-text-with-title')
    ),
    [SliceNames.THREE_COLUMN_TABLE]: loadable(() =>
        import('./components/three-column-table')
    ),
    [SliceNames.TWO_COLUMN_TABLE]: loadable(() =>
        import('./components/two-column-table')
    ),
    [SliceNames.VIDEO]: loadable(() => import('./components/video')),
    [SliceNames.INFO_BANNER]: loadable(() =>
        import('./components/info-banner')
    ),
    [SliceNames.FIFTY_FIFTY]: loadable(() =>
        import('./components/fifty-fifty-split')
    ),
    [SliceNames.TEXT_ME_THE_APP]: loadable(() =>
        import('./components/text-me-the-app')
    ),
};

export default COMPONENTS;
